(function () {
    'use strict';

    angular.module('app.iCal', [
        'app.core',
        'app.widgets'
    ]);
})();
